import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'

import GA4 from 'helpers/ga4'

import { screenSize } from 'styles/shared'

import Resource from 'types/Resource'

import { color } from 'styles/colors'

import Tooltip from 'components/Tooltip'

type Props = {
  resource: Resource
}

const HelpResourceRow = ({ resource }: Props) => {
  const onClickLink = (name: string) => {
    GA4.sendEvent({
      category: 'Resources',
      action: 'Article Viewed',
      label: name
    })
  }

  if (resource == null) {
    return <></>
  }

  return (
    <S.TableRow key={resource.name}>
      <S.NameCell>
        <Tooltip title={'Click to view'} placement="top">
          <S.ThumbnailLink
            href={resource.url}
            onClick={() => {
              onClickLink(resource.name)
            }}
            target="_blank"
            rel="noreferrer"
          >
            <S.PictureAsPdfOutlined
              src={'/img/pdf_icon.svg'}
              alt={`${resource.name} help resource thumbnail`}
            />
            {resource.name}
          </S.ThumbnailLink>
        </Tooltip>
      </S.NameCell>

      <S.DescriptionCell>
        {resource.description}
      </S.DescriptionCell>

      <S.DateCell>
        {resource.createdAt}
      </S.DateCell>
    </S.TableRow>
  )
}
export default HelpResourceRow

const cellStyle = css`
  padding: 5px;
  min-width: 120px;

  @media ${screenSize.medium} {
    font-size: 12px;
  }
`

const S = {
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 15px;
  `,
  ThumbnailLink: styled.a`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${color('warrantyText')};
    font-weight: 500;
    text-decoration: none;

    &:hover {
      color: ${color('warrantyText')};
    }
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: center;
    flex-basis: 25%;
  `,
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 25%;
  `,
  PictureAsPdfOutlined: styled.img`
    margin: 5px;

    @media ${screenSize.medium} {
      width: 30px;
      height: 30px;
    }
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
    margin: 10px;
    @media ${screenSize.small} {
      align-items: unset;
    }
  `
}
